<button mat-icon-button class="actions-buttons" *ngIf="checkActionsAndActualVersion || task"
    [disabled]="isDeleting || isOrphan">
    <mat-icon matTooltip="Recalculate" (click)="recalculateZCVersion($event)" class="actions-mat-icons">
        replay
    </mat-icon>
</button>